/** Adapter between the API notification (raw Prisma) and the UI `NotificationItem`. */

import type { NotificationItem, NotificationType, NotifSeverity } from "@/types";

export interface ApiNotification {
  id: string;
  createdAt?: string | null;
  userId?: string | null;
  type: NotificationType;
  severity: NotifSeverity;
  title: string;
  body?: string | null;
  isRead: boolean;
  entityType?: string | null;
  entityId?: string | null;
}

function formatDateTime(raw: string | null | undefined): string {
  if (!raw) return "";
  const d = new Date(raw);
  if (Number.isNaN(d.getTime())) return "";
  const p = (n: number) => String(n).padStart(2, "0");
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(d.getHours())}:${p(d.getMinutes())}`;
}

export function toNotification(api: ApiNotification): NotificationItem {
  return {
    id: api.id,
    type: api.type,
    severity: api.severity,
    title: api.title,
    body: api.body ?? undefined,
    entityType: api.entityType ?? undefined,
    entityId: api.entityId ?? undefined,
    at: formatDateTime(api.createdAt),
    read: Boolean(api.isRead),
  };
}
